import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { AzureDataLakeStoreCosmosStructuredStreamFileCopySource } from 'app/model/pipeline/copysource/azure-data-lake-store-cosmos-structured-stream.copysource';
import { ValueAdapter } from '../../value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureDataLakeStoreCosmosStructuredStreamFileCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        partitionIndex: '*'
    }
})
export class AzureDataLakeStoreCosmosStructuredStreamFileCopySourceAdapter extends CopySourceAdapter<
    AzureDataLakeStoreCosmosStructuredStreamFileCopySource,
    Model.AzureDataLakeStoreCosmosStructuredStreamSource
> {
    protected override async _toResource(
        copySource: AzureDataLakeStoreCosmosStructuredStreamFileCopySource
    ): Promise<Model.AzureDataLakeStoreCosmosStructuredStreamSource> {
        const result: Model.AzureDataLakeStoreCosmosStructuredStreamSource = this.getCommonCopySourceProperties(
            copySource,
            'AzureDataLakeStoreCosmosStructuredStreamSource'
        );
        result.partitionIndex = ValueAdapter.toResource(
            copySource,
            AzureDataLakeStoreCosmosStructuredStreamFileCopySource.PARTITION_INDEX
        );
        return result;
    }

    protected override async _toModel(
        adlsCosmosStructuredStreamSource: Model.AzureDataLakeStoreCosmosStructuredStreamSource,
        copyActivity: CopyActivity
    ): Promise<AzureDataLakeStoreCosmosStructuredStreamFileCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            AzureDataLakeStoreCosmosStructuredStreamFileCopySource.MODEL,
            adlsCosmosStructuredStreamSource,
            copyActivity
        ) as AzureDataLakeStoreCosmosStructuredStreamFileCopySource;

        ValueAdapter.toModel(
            result,
            AzureDataLakeStoreCosmosStructuredStreamFileCopySource.PARTITION_INDEX,
            adlsCosmosStructuredStreamSource.partitionIndex
        );

        return result;
    }
}
